// 导入组件，组件必须声明 name
import MainComponent from './src/index';
import vueI18n from '@/i18n/locale';
import { putMsgRead } from '@/components/message-center-list/src/services';
import { ReadStatus } from '@/config/constants';
import { trackEvent } from '@/plugins/plugin-init-omega';
import { gtrCollectTrackCommonData, gtrTrackCommonData } from '@/utils/gattaran-track-event';

// 导出组件
let instance;
let IVue = null;
class MessagePlugin {
  constructor() {}
  install(Vue, options, isRegisterGlobal) {
    const { config, ...other } = options;
    if (isRegisterGlobal) {
      Vue.component(MainComponent.name, MainComponent);
    }
    IVue = Vue;
  }

  open(options) {
    let MainComponentConstructor = IVue.extend(MainComponent);
    if (!instance) {
      instance = new MainComponentConstructor({
        i18n: vueI18n,
        data: {
          ...options,
          datetime: options.sendTime,
          unRead: +options.status === ReadStatus.UN_READ,
          show: false,
        },
      });
      instance.$mount();
      document.body.appendChild(instance.$el);
    }
    // 如果已经打开不进行后面操作
    if (instance.show) return;
    instance.show = true;
    instance._timer = setTimeout(() => {
      if (instance) {
        const { module } = gtrCollectTrackCommonData();
        trackEvent('sailing_m_gtr_popup_msg_sw', '系统公告消息卡片曝光', {
          ...gtrTrackCommonData(),
          pre_url: window.location.href,
          module, // 模块信息
          current_popup: options.messageId,
          current_popup_type: '消息卡片',
          system: 1,
        });
        if (options.messageId) {
          putMsgRead({ isAll: 0, isCard: 1, msgIds: [options.messageId] }).then((r) => {
            console.log('卡片读取成功');
          });
        }
        // instance.show = false;
      }
    }, 3 * 1000);
    return instance;
  }

  close() {
    if (instance) {
      instance.show = false;
    }
  }
}

export default new MessagePlugin();
